const EFFECTIVE_DATE = '8/18/2025';
const LAST_UPDATED = '2/17/2026';

export const SMS_POLICY = `# SMS Terms and Conditions

**Effective Date:** ${EFFECTIVE_DATE}  
**Last Updated:** ${LAST_UPDATED}

## What We Use SMS For

When you provide your phone number, we use it **exclusively** for sending one-time authentication magic links. That's it.  
**Providing your phone number is optional.** You can always use email for authentication instead. 

**We do not send:**
- Account notifications
- Promotional messages
- Marketing
- Any other SMS messages

## How Your Phone Number Protects Your Account

Your phone number is used for [passwordless authentication](/security#auth). When you sign in, we send a one-time magic link to your phone — proving that you have access to the number on file.

Your patient data is additionally encrypted on your device using keys protected by biometric authentication (Face ID, Touch ID, or device passcode). This means that even if someone intercepts your magic link, they cannot read data stored on your phone without also having physical access to the device and passing biometric verification.

For complete details on how we protect your data, see our [Security](/security) page.

## Your Phone Number

- We collect your phone number only if you choose SMS as your authentication method
- Your number is stored securely and encrypted
- We **never** sell or share your phone number with third parties
- We **only** send authentication magic links — no other messages
- **Message frequency varies.** You will receive one (1) SMS message each time you sign in using SMS authentication. No recurring or scheduled messages are sent
- Standard message and data rates from your carrier may apply
- **Carriers are not liable for delayed or undelivered messages**

## Opting Out

You can stop receiving SMS messages at any time by:

- Switching to email-based authentication in your account settings
- Replying **STOP** to any message from us
- Contacting us at [privacy@rescueally.org](mailto:privacy@rescueally.org)

**Important:** If you reply STOP without first switching to email authentication, you will not be able to log in until you update your contact method. We recommend switching to email in your account settings before opting out of SMS.

## Compliance

Our SMS services comply with:

- Telephone Consumer Protection Act (TCPA)
- Cellular Telecommunications Industry Association (CTIA) guidelines
- HIPAA requirements for healthcare data

## Contact

These SMS Terms are part of our overall [Terms of Service](/terms).

Questions about our SMS services?

**Rescue Ally Privacy Team**  
Email: [privacy@rescueally.org](mailto:privacy@rescueally.org)  
Phone: +1 (303)-578-8161
`;
